// src/lib/opportunity/repProposalContact.ts

import type { AuthProfile } from "@/hooks/authStateModel";
import type { RepContactLocation } from "@/lib/opportunity/fetchRepContactLocation";
import type { ProposalContactInfo } from "./proposalContactTypes";
import { proposalContactOrgWithLocation } from "./proposalContactDisplay";

export function formatLocationAddress(loc: RepContactLocation | null | undefined): string | null {
  if (!loc) return null;
  const line1 = loc.address_1?.trim();
  const line2 = loc.address_2?.trim();
  const cityState = [loc.city?.trim(), loc.state?.trim()].filter(Boolean).join(", ");
  const postal = loc.postal_code?.trim();
  const cityLine = [cityState, postal].filter(Boolean).join(" ");
  const parts = [line1, line2, cityLine].filter(Boolean);
  return parts.length > 0 ? parts.join("\n") : null;
}

export function repProposalContactOverride(args: {
  base: ProposalContactInfo;
  profile: AuthProfile | null | undefined;
  location: RepContactLocation | null | undefined;
}): ProposalContactInfo {
  const { base, profile, location } = args;
  if (!profile) return base;
  const personName = profile.display_name?.trim() || profile.full_name?.trim() || null;
  const phone =
    location?.phone?.trim() ||
    profile.work_phone?.trim() ||
    profile.personal_phone?.trim() ||
    null;
  const email = profile.email?.trim() || null;
  const address = formatLocationAddress(location);
  const usesLocationContact = Boolean(
    location && (address || location.phone?.trim() || location.name?.trim()),
  );
  return {
    orgName: usesLocationContact
      ? proposalContactOrgWithLocation(base.orgName, location?.name)
      : base.orgName,
    personName,
    address,
    phone,
    email,
  };
}
